export default {
  DEBUG: false,
  API_URI: 'https://api.loading.se',
}
